<div class="home">
  <app-hero-section></app-hero-section>
  <app-about-section></app-about-section>
  <app-gallery-section></app-gallery-section>
  <app-faq-section></app-faq-section>
  <app-feedback-section></app-feedback-section>
  <app-contact-section></app-contact-section>
  <app-journey-section></app-journey-section>
  <app-experience-section></app-experience-section>
  <app-services-section></app-services-section>
</div>
